import React from 'react';

const footer = (props) => {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <ul>
        <li><a href='https://www.cdphp.com/legal/non-discrimination' target='_blank' rel='noopener noreferrer'>Non-Discrimination</a></li>
        <li><a href='https://www.cdphp.com/legal/languages' target='_blank' rel='noopener noreferrer'>Languages</a></li>
        <li><a href='https://www.cdphp.com/legal/privacy-practices' target='_blank' rel='noopener noreferrer'>Privacy Practices</a></li>
        <li><a href='https://www.cdphp.com/legal/terms-of-use' target='_blank' rel='noopener noreferrer'>Terms of Use</a></li>
        <li><a href='https://www.cdphp.com/legal/privacy-policy' target='_blank' rel='noopener noreferrer'>Privacy Policy</a></li>
      </ul>
      <div className='copyright'>
        <p>&copy;{currentYear} CDPHP&reg;. All Rights Reserved</p>
        <p>Capital District Physicians&rsquo; Health Plan, Inc.</p>
        <p>6 Wellness Way, Latham, NY 12110</p>
      </div>
      <div className='disc'>
        {props.medicare === 'true' ? <p><sup>&dagger;</sup>For more information on star ratings, visit www.medicare.gov.</p> : null}
        {props.smallBiz === 'true' ? <div><p>*NCQA Health Plan Ratings 2024</p></div> : null}
        {props.jdpower === 'true' ? <p>**For J.D. Power 2025 award information, visit jdpower.com/awards</p> : null}
        {props.medicareHours === 'true' ? <p><sup>&Dagger;</sup>Our hours are 8 a.m. – 8 p.m. seven days a week, October 1 – March 31. From April 1 to September 30, Monday – Friday, our hours are 8 a.m. to 8 p.m. A voice messaging service is used weekends, after-hours, and federal holidays. Calls will be returned within one business day.</p> : null}
        {props.medicareHours === 'true' ? <p>CDPHP is an HMO and PPO plan that contracts with the federal government. Enrollment in CDPHP Medicare plans depends on contract renewal.</p> : null}
        {props.medicareHours === 'true' ? <p>Y0019_25_27310 last updated 10/1/2024</p> : null}
        {props.results === 'true' ? <p>*<strong>Please note:</strong> This is an estimate and does not mean that you are eligible for these programs.<br />Only NY State of Health can determine your eligibility for Medicaid, Child Health Plus, the Essential Plan, and Qualified Health Plans.</p> : null}
      </div>
    </footer>
  );
};

export default footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js